// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"IconButton_iconButton__2BD1c","fullRounded":"IconButton_fullRounded__1O2Zs","square":"IconButton_square__3YcZU"};